import React, { useState } from 'react'
import QRCode from 'react-qr-code'
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'rsuite';
import { registerEvent } from '../../../actions/client';

export const Eventos = () => {
    const dispatch = useDispatch();
    const cliente = useSelector(state => state.client);
    const [loadingBtn, setloadingBtn] = useState(false);
    const [QR, setQR] = useState(false)

    const handdleClick = async () => {
        setloadingBtn(true);
        await dispatch(registerEvent());
        setloadingBtn(false);
    }

    return (
        <div >
            <div className="card" style={{width: '18rem'}}>
                <img src="/assets/images/byTheBye4_0.jpg" className="card-img-top" alt="..." />
                <div className="card-body">
                    {/* <h5 className="card-title">BY THE BYE</h5> */}
                    <p className="card-text">¡Ya llegó! ¡Ya está aquí! La mejor before party en la casa del perreo, con barra libre hasta las 12:00 a.m y el mejor ambiente para empezar la fiesta antes de nuestro viaje🥳🥴<br />
Accesos completamente en cortesía para todos nuestros viajeros y viajeras, con el código QR que aparecerá en su perfil días antes del evento 💠 b
Los esperamos a partir de las 9:00 p.m. en MACA AMERICANA este VIERNES 2 DE DICIEMBRE ¡No te lo puedes perder! 🥳💠</p>
                </div>
                <div className="card-footer" align="center">
                    {!!cliente.eventoTemp 
                    ?   <>
                            <QRCode value={`https://alternativo.viveskyfest.com/evento/${cliente.eventoTemp}`} size={180}/>
                            <span className="text-primary">Codigo de acceso</span>
                        </>
                    :   <Button
                            // appearance="ghost"
                            color="green"
                            loading={loadingBtn}
                            onClick={handdleClick}
                        >
                            Generar codigo de acceso
                        </Button>
                    }
                </div>
            </div>
        </div>
    )
}
